import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startCase, get, isEqual, isEmpty } from 'lodash';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import {
  dispatchLogoutAction,
  updateProfileAction,
  getUserProfileDataAction,
} from '../../actions/authentication';
import { deleteGuestVehicleAction } from '../../actions/app.action';
import { getButtonHandlerCta, getErrorDescription, getErrorTitle } from '../../selectors';
import {
  customErrorCodes,
  exceptionComponentPageTypes,
  apiResponseCodes,
} from '../../constants/globals';
import { constants } from '../../constants/configuration';
import routes from '../../routes';

import './Account.scss';

const Header = asyncRoute(() => import('../../components/Header'));
const Button = asyncRoute(() => import('../../components/elements/Button'));
const UpdateProfileField = asyncRoute(() => import('../../components/Popup/UpdateProfileField'));
const VehicleDetailsComponent = asyncRoute(() => import('../../components/Popup/VehicleDetails'));
const RemoveFormField = asyncRoute(() => import('../../components/Popup/RemoveFormField'));
const ExceptionComponent = asyncRoute(() => import('../../components/ExceptionComponent'));

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpdateProfileFieldPopup: false,
      showRemoveFormFieldPopup: false,
      showAddNewVehiclePopup: false,
      fieldType: '',
      page: routes.containers.account,
      vehicleId: '',
      showErrorPopup: false,
      errorContent: {
        title: '',
        description: '',
        buttonCta: '',
      },
      handleErrorCTA: null,
      errorPopupStyleType: exceptionComponentPageTypes.halfSize,
      vehicleNumberDuplicateError: '',
    };
  }

  componentDidMount() {
    const { loginData } = this.props;
    const { id: guestId } = loginData;

    if (isEmpty(guestId)) {
      this.setState({
        showErrorPopup: true,
        showUpdateProfileFieldPopup: false,
        showRemoveFormFieldPopup: false,
        showAddNewVehiclePopup: false,
        errorContent: {
          title: getErrorTitle({ code: customErrorCodes.contextlessURLHit }),
          description: getErrorDescription({ code: customErrorCodes.contextlessURLHit }),
          buttonCta: getButtonHandlerCta({ code: customErrorCodes.contextlessURLHit }),
        },
        handleErrorCTA: this.handleContextlessURLHitErrorPopupCTA,
        errorPopupStyleType: exceptionComponentPageTypes.fullSize,
      });
    } else {
      this.props.getUserProfileDataAction(guestId);
    }
  }

  componentWillReceiveProps(nextProps) {
    //check if login data is updated
    if (
      !isEqual(get(this.props, 'loginData'), get(nextProps, 'loginData')) &&
      !isEmpty(get(nextProps, 'loginData'))
    ) {
      this.setState({
        showUpdateProfileFieldPopup: false,
        showRemoveFormFieldPopup: false,
        showAddNewVehiclePopup: false,
        fieldType: '',
        vehicleId: '',
      });
    }
  }

  handleContextlessURLHitErrorPopupCTA = () => {
    // Reload and open webapp's home
    window.location.replace(window.location.origin);
  };

  handleLogoutClick = () => {
    localStorage.setItem('GuestLoginData', JSON.stringify({}));
    localStorage.setItem('AuthData', JSON.stringify({}));
    this.props.dispatchLogoutAction();
    this.onBackClick();
  };

  onBackClick = () => {
    this.props.history.goBack();
  };

  handleEditClick = (fieldType, vehicleId) => {
    this.setState({
      fieldType,
      vehicleId,
      showUpdateProfileFieldPopup: true,
    });
  };

  onCloseUpdateProfileFieldPopup = () => {
    this.setState({
      showUpdateProfileFieldPopup: false,
      fieldType: '',
    });
  };

  handleUpdateCTA = (formFieldsState) => {
    const { fieldType } = this.state;
    const { id: guestId } = this.props.loginData;
    if (isEqual(fieldType, 'addNewVehicle')) {
      let vehicleReqBody = {
        guestVehicles: [formFieldsState],
      };
      this.props.updateProfileAction(vehicleReqBody, guestId).then((response) => {
        if (!apiResponseCodes.SUCCESS.includes(get(response, 'status', ''))) {
          this.setState({ vehicleNumberDuplicateError: get(response, 'message', '') });
        }
      });
    } else {
      this.setState(
        {
          showUpdateProfileFieldPopup: false,
        },
        () => {
          this.props.updateProfileAction(formFieldsState, guestId).then((response) => {
            if (!apiResponseCodes.SUCCESS.includes(get(response, 'status', ''))) {
              this.setState({ vehicleNumberDuplicateError: get(response, 'message', '') });
            }
          });
        },
      );
    }
  };

  onCloseRemoveFormFieldPopup = () => {
    this.setState({
      showRemoveFormFieldPopup: false,
    });
  };

  handleRemoveVehicleCTA = (vehicleId) => {
    this.setState({
      showUpdateProfileFieldPopup: false,
      fieldType: '',
      vehicleId,
      showRemoveFormFieldPopup: true,
    });
  };

  handleRemoveFormFieldCTA = () => {
    const { id: guestId } = this.props.loginData;
    const { vehicleId } = this.state;
    let deleteGuestVehicleReqBody = {
      guestVehicleIds: [vehicleId],
      guestId: guestId,
    };
    this.props.deleteGuestVehicleAction(deleteGuestVehicleReqBody, guestId);
  };

  handleAddNewVehicle = () => {
    this.setState({
      showUpdateProfileFieldPopup: false,
      showAddNewVehiclePopup: true,
      fieldType: 'addNewVehicle',
    });
  };

  onCloseAddNewVehiclePopup = () => {
    this.setState({
      showAddNewVehiclePopup: false,
      vehicleNumberDuplicateError: '',
    });
  };

  render() {
    const {
      showUpdateProfileFieldPopup,
      showAddNewVehiclePopup,
      showRemoveFormFieldPopup,
      fieldType,
      vehicleId,
      page,
      showErrorPopup,
      errorContent,
      handleErrorCTA,
      errorPopupStyleType,
      vehicleNumberDuplicateError,
    } = this.state;
    const { name, email, primaryPhoneNumber, guestVehicles } = this.props.loginData;
    return (
      <>
        <Header onBackClick={this.onBackClick} identifier={routes.containers.account} />
        <div className="account">
          {/* accounts general section */}
          <div className="account_card-section">
            <div className="account_card-section_header">{constants.account.general}</div>
            <div className="section">
              <div className="section-item">
                <span className="account_label">{constants.account.label.name}</span>
                <span className="account_text">{startCase(name)}</span>
              </div>
              <div className="account_edit-btn" onClick={() => this.handleEditClick('name')}>
                {constants.account.editBtn}
              </div>
            </div>
            <div className="section">
              <div className="section-item">
                <span className="account_label">{constants.account.label.phoneNumber}</span>
                <span className="account_text">{primaryPhoneNumber}</span>
              </div>
            </div>
            {email && (
              <div className="section">
                <div className="section-item">
                  <span className="account_label">{constants.account.label.email}</span>
                  <span className="account_text">{email}</span>
                </div>
                <div className="account_edit-btn" onClick={() => this.handleEditClick('email')}>
                  {constants.account.editBtn}
                </div>
              </div>
            )}
            <span className="account_line-break" />
            <span className="account_line-break" />
          </div>

          {/* accounts vehicle section */}
          <div className="account_card-section">
            <div className="account_card-section_header">{constants.account.vehicle}</div>
            {guestVehicles && guestVehicles.length > 0 ? (
              <>
                {guestVehicles.map((guestVehicle, index) => (
                  <div className="section" key={index}>
                    <div className="section-item">
                      <span className="account_label">{constants.account.label.vehicle}</span>
                      <span className="account_text">{guestVehicle.vehicleNumber}</span>
                      <span className="account_text">{get(guestVehicle, 'identification')}</span>
                    </div>
                    <div
                      className="account_edit-btn"
                      onClick={() => this.handleEditClick('guestVehicles', guestVehicle.id)}
                    >
                      {constants.account.editBtn}
                    </div>
                  </div>
                ))}
                <span className="account_add-vehicle-link" onClick={this.handleAddNewVehicle}>
                  {constants.account.addVehicle}
                </span>
              </>
            ) : (
              <div className="account_add-vehicle">
                <Button onClick={this.handleAddNewVehicle} content={constants.account.addVehicle} />
              </div>
            )}
            <span className="account_line-break" />
            <span className="account_line-break" />
          </div>

          {/* accounts logout button */}
          <span className="account_logout">
            <Button onClick={this.handleLogoutClick} content={constants.drawer.logoutCTA} />
          </span>
        </div>
        {showUpdateProfileFieldPopup && (
          <UpdateProfileField
            openSegmentPopup={showUpdateProfileFieldPopup}
            dismissSegmentPopup={this.onCloseUpdateProfileFieldPopup}
            fieldType={fieldType}
            vehicleId={vehicleId}
            page={page}
            handleBtnCTA={(formFieldsState) => this.handleUpdateCTA(formFieldsState)}
            handleRemoveVehicleCTA={(vehicleId) => this.handleRemoveVehicleCTA(vehicleId)}
          />
        )}
        {showRemoveFormFieldPopup && (
          <RemoveFormField
            openSegmentPopup={showRemoveFormFieldPopup}
            dismissSegmentPopup={this.onCloseRemoveFormFieldPopup}
            handleBtnCTA={this.handleRemoveFormFieldCTA}
          />
        )}
        {showAddNewVehiclePopup && (
          <VehicleDetailsComponent
            openSegmentPopup={showAddNewVehiclePopup}
            dismissSegmentPopup={this.onCloseAddNewVehiclePopup.bind(this)}
            page={page}
            vehicleNumberDuplicateError={vehicleNumberDuplicateError}
            handleBtnCTA={(formFieldsState) => this.handleUpdateCTA(formFieldsState)}
          />
        )}
        {showErrorPopup && (
          <ExceptionComponent
            pageType={errorPopupStyleType}
            openSegmentPopup={showErrorPopup}
            title={get(errorContent, 'title')}
            description={get(errorContent, 'description')}
            buttonCta={get(errorContent, 'buttonCta')}
            handleButtonCta={handleErrorCTA}
          />
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({
    loginData: get(state, 'authentication.loginData', {}),
  }),
  {
    dispatchLogoutAction,
    updateProfileAction,
    getUserProfileDataAction,
    deleteGuestVehicleAction,
  },
)(Account);
